/* =========================================================
   SweetBites — Flavor Picker
   ========================================================= */
(function () {
  'use strict';
  if (window.__FLAVOR_PICKER_INIT) return;
  if (!document.getElementById('p-grid')) return;
  window.__FLAVOR_PICKER_INIT = 1;

  var CFG = window.FLAVOR_PICKER_CFG || {};
  var LANG = localStorage.getItem('sb_lang') || 'zh';

  function dots(s) {
    return String(s == null ? '' : s).replace(
      /__dot__/g,
      "<span class='dot'>\u2022</span>",
    );
  }

  var SRC = document.getElementById('p-flavor-src');

  function zhOf(el) {
    if (!el) return '';
    return (el.dataset.zh != null ? el.dataset.zh : el.innerHTML).trim();
  }
  function enOf(el) {
    if (!el) return '';
    return (el.dataset.en || zhOf(el)).trim();
  }

  var BEST = String(CFG.bestsellers || '1,7,10')
    .split(',')
    .map(function (n) {
      return parseInt(n, 10);
    })
    .filter(function (n) {
      return n > 0;
    });

  var F = [];
  if (SRC) {
    Array.prototype.forEach.call(
      SRC.querySelectorAll('[data-flavor-id]'),
      function (node) {
        var id = +node.dataset.flavorId;
        var title = node.querySelector('.flavor-title');
        var benefit = node.querySelector('.flavor-benefit');
        var photo = node.querySelector('.flavor-photo');
        F.push({
          id: id,
          cn: zhOf(title),
          en: enOf(title),
          tc: zhOf(benefit),
          te: enOf(benefit),
          img: photo ? photo.getAttribute('src') : '',
          best: BEST.indexOf(id) > -1 ? 1 : 0,
          code: title ? title.dataset.track || '' : '',
        });
      },
    );
  }

  function srcNode(id) {
    return SRC ? SRC.querySelector('[data-flavor-id="' + id + '"]') : null;
  }

  var BY = {};
  F.forEach(function (f) {
    BY[f.id] = f;
  });
  if (!BEST.length) BEST = [1, 7, 10, 3, 11, 16, 5, 2];

  /* ---- plans ---- */
  function money(x) {
    return (Math.round(x * 100) / 100).toFixed(2);
  }
  var PR = CFG.prices || {};
  var PLANS = {
    trial: { key: 'trial', n: 5, price: PR.trial || 148, per: '' },
    classic: { key: 'classic', n: 10, price: PR.classic || 238, per: '' },
    monthly: {
      key: 'monthly',
      n: 7,
      price: PR.monthly || 638,
      per: '',
      weekly: 1,
    },
  };
  PLANS.trial.per = money(PLANS.trial.price / 5);
  PLANS.classic.per = money(PLANS.classic.price / 10);
  PLANS.monthly.per = money(PLANS.monthly.price / 28);
  var ORDER = ['trial', 'classic', 'monthly'];

  var PLAN_NAMES = {
    trial: 'Trial Pack',
    classic: 'Classic Set',
    monthly: 'Monthly Plan',
  };

  function trackEcommerce(planKey) {
    return {
      currency: CFG.currency || 'MYR',
      value: PLANS[planKey].price,
      items: trackItems(planKey),
    };
  }

  function trackItems(planKey) {
    return [
      {
        item_id: String((CFG.variants && CFG.variants[planKey]) || planKey),
        item_name: PLAN_NAMES[planKey],
        item_category: 'plan',
        price: PLANS[planKey].price,
        quantity: 1,
      },
    ];
  }

  /* ---- helper: resolve CFG string with {placeholders} ---- */
  function tpl(str, data) {
    return str
      .replace(/\{plan\}/g, data.plan != null ? data.plan : '')
      .replace(/\{n\}/g, data.n != null ? data.n : '')
      .replace(/\{N\}/g, data.N != null ? data.N : '')
      .replace(/\{k\}/g, data.k != null ? data.k : '')
      .replace(/\{price\}/g, data.price != null ? data.price : '')
      .replace(/\{per\}/g, data.per != null ? data.per : '');
  }

  var UI = {
    en: {
      nm: function (f) {
        return f.en;
      },
      sb: function (f) {
        return f.cn;
      },
      tg: function (f) {
        return f.te;
      },
      pn: function (p) {
        var k = p.key || 'classic';
        return CFG.ui && CFG.ui.plans && CFG.ui.plans[k]
          ? CFG.ui.plans[k].en
          : DEFAULT_PLAN_NAMES[k]
            ? DEFAULT_PLAN_NAMES[k].en
            : '';
      },
      meta: function (p) {
        var k = p.key || 'classic';
        var base =
          CFG.ui && CFG.ui.planMeta && CFG.ui.planMeta[k]
            ? CFG.ui.planMeta[k].en
            : DEFAULT_PLAN_META[k].en;
        return tpl(base, { per: p.per });
      },
      title: 'Now, pick your flavors',
      sub: function (p) {
        var key = p.weekly
          ? 'subMonthly'
          : S.plan === 'trial'
            ? 'subTrial'
            : 'subClassic';
        return tpl(UI._cfg.en[key] || '', {
          plan: p.en || '',
          n: p.n,
          price: p.price,
        });
      },
      steps: ['Your plan', 'Your flavors', 'Checkout'],
      yourSet: 'Your set',
      clear: 'Clear all ↺',
      cleared: 'Cleared.',
      undo: 'Undo',
      empty: 'Nothing yet — Classic Original is the crowd favorite.',
      auto: 'Auto-fill the rest with bestsellers →',
      weekTag: 'Week 1 of 4',
      weekNote:
        'Swap flavors for later weeks anytime — via WhatsApp or your account.',
      rec: 'Bestseller',
      add: 'Add',
      need: function (k) {
        return tpl(UI._cfg.en.need || 'Pick {k} more bottle(s)', { k: k });
      },
      go: function (p) {
        return tpl(UI._cfg.en.go || 'Checkout · RM{price} →', { price: p });
      },
      prog: function (n, N) {
        return tpl(UI._cfg.en.prog || '{n} of {N} picked', { n: n, N: N });
      },
      progDone: 'All picked — ready to check out ✓',
      trimmed: function (n) {
        return tpl(
          UI._cfg.en.trimmed ||
            'Plan changed — we kept the first {n} bottles you picked.',
          { n: n },
        );
      },
      nudge: {},
      switchTo: {},
      sugarLbl: 'Sweetness',
      sugarNote: 'One level for the whole set',
      sugarName: function (s) {
        var cfg =
          CFG.ui && CFG.ui.sugar && CFG.ui.sugar[s.k]
            ? CFG.ui.sugar[s.k].en
            : s.en;
        return cfg || s.en;
      },
      foot: 'Cold-chain delivery · Stewed fresh after you order',
      adding: 'Adding…',
      cartErr: 'Could not add to cart — please try again.',
    },
    zh: {
      nm: function (f) {
        return f.cn;
      },
      sb: function (f) {
        return f.en;
      },
      tg: function (f) {
        return f.tc;
      },
      pn: function (p) {
        var k = p.key || 'classic';
        return CFG.ui && CFG.ui.plans && CFG.ui.plans[k]
          ? CFG.ui.plans[k].zh
          : DEFAULT_PLAN_NAMES[k]
            ? DEFAULT_PLAN_NAMES[k].zh
            : '';
      },
      meta: function (p) {
        var k = p.key || 'classic';
        var base =
          CFG.ui && CFG.ui.planMeta && CFG.ui.planMeta[k]
            ? CFG.ui.planMeta[k].zh
            : DEFAULT_PLAN_META[k].zh;
        return tpl(base, { per: p.per });
      },
      title: '现在，挑你的口味',
      sub: function (p) {
        var key = p.weekly
          ? 'subMonthly'
          : S.plan === 'trial'
            ? 'subTrial'
            : 'subClassic';
        return tpl(UI._cfg.zh[key] || '', {
          plan: p.cn || '',
          n: p.n,
          price: p.price,
        });
      },
      steps: ['选套餐', '挑口味', '去结账'],
      yourSet: '你的一组',
      clear: '清空重选 ↺',
      cleared: '已清空。',
      undo: '撤销',
      empty: '还没选——经典原味最受欢迎。',
      auto: '用人气口味填满剩下的 →',
      weekTag: '第 1 / 4 周',
      weekNote: '之后每周可换口味——WhatsApp 或账户内更改。',
      rec: '人气之选',
      add: '加入',
      need: function (k) {
        return tpl(UI._cfg.zh.need || '还差 {k} 瓶', { k: k });
      },
      go: function (p) {
        return tpl(UI._cfg.zh.go || '去结账 · RM{price} →', { price: p });
      },
      prog: function (n, N) {
        return tpl(UI._cfg.zh.prog || '已选 {n} / {N} 瓶', { n: n, N: N });
      },
      progDone: '已选满——可以去结账了 ✓',
      trimmed: function (n) {
        return tpl(
          UI._cfg.zh.trimmed || '已切换套餐——保留了你先选的 {n} 瓶。',
          { n: n },
        );
      },
      nudge: {},
      switchTo: {},
      sugarLbl: '甜度',
      sugarNote: '整组统一甜度',
      sugarName: function (s) {
        var cfg =
          CFG.ui && CFG.ui.sugar && CFG.ui.sugar[s.k]
            ? CFG.ui.sugar[s.k].zh
            : s.cn;
        return cfg || s.cn;
      },
      foot: '冷链配送 · 接单后现炖',
      adding: '加入中…',
      cartErr: '加入购物车失败——请重试。',
    },
    _cfg: CFG.ui || {},
  };

  /* ---- default plan names/meta (used as fallback) ---- */
  var DEFAULT_PLAN_NAMES = {
    trial: { zh: '体验装', en: 'Trial Pack' },
    classic: { zh: '经典套装', en: 'Classic Set' },
    monthly: { zh: '月订计划', en: 'Monthly Plan' },
  };
  var DEFAULT_PLAN_META = {
    trial: { zh: '5 瓶 · 每瓶 RM{per}', en: '5 bottles · RM{per} each' },
    classic: { zh: '10 瓶 · 每瓶 RM{per}', en: '10 bottles · RM{per} each' },
    monthly: {
      zh: '每月 28 瓶 · 每瓶 RM{per}',
      en: '28 bottles/mo · RM{per} each',
    },
  };

  /* Populate nudge & switchTo from CFG or defaults */
  var DN = {
    trial: {
      zh: '想要更多？<b>经典套装</b> 10 瓶，每瓶 RM{per}。',
      en: 'Want more? <b>Classic Set</b> holds 10 at RM{per} each.',
    },
    classic: {
      zh: '升级<b>月订</b>——每瓶 RM{per}，每周 7 瓶新鲜配送，免运费。',
      en: 'Go <b>Monthly</b> — RM{per} per bottle, 7 fresh bottles weekly, free delivery.',
    },
    monthly: {
      zh: '已是最划算 ✓——而且每周都可以换口味。',
      en: 'Best value ✓ — and you can swap flavors every week.',
    },
  };
  var DS = {
    trial: { zh: '换成体验装', en: 'Switch to Trial' },
    classic: { zh: '换成经典套装', en: 'Switch to Classic Set' },
    monthly: { zh: '升级月订', en: 'Go Monthly' },
  };
  ['en', 'zh'].forEach(function (l) {
    UI[l].nudge = {};
    UI[l].switchTo = {};
    ORDER.forEach(function (k) {
      var cfgNudge =
        CFG.ui && CFG.ui.nudge && CFG.ui.nudge[k] ? CFG.ui.nudge[k][l] : null;
      UI[l].nudge[k] = cfgNudge || DN[k][l];
      var cfgSwitch =
        CFG.ui && CFG.ui.switchTo && CFG.ui.switchTo[k]
          ? CFG.ui.switchTo[k][l]
          : null;
      UI[l].switchTo[k] = cfgSwitch || DS[k][l];
    });
  });

  /* Merge CFG.ui string overrides into UI */
  if (CFG.ui) {
    for (var _l in CFG.ui) {
      if (
        UI[_l] &&
        _l !== 'plans' &&
        _l !== 'planMeta' &&
        _l !== 'sugar' &&
        _l !== 'nudge' &&
        _l !== 'switchTo'
      ) {
        for (var _k in CFG.ui[_l]) {
          var v = CFG.ui[_l][_k];
          if (typeof v !== 'string') continue;
          if (v === '') continue;
          if (typeof UI[_l][_k] === 'function') {
            continue;
          } else if (Array.isArray(UI[_l][_k])) {
            UI[_l][_k] = v.split(',').map(function (s) {
              return s.trim();
            });
          } else {
            UI[_l][_k] = v;
          }
        }
      }
    }
  }

  function t() {
    return UI[LANG];
  }

  /* ---- state ---- */
  var urlPlan = new URLSearchParams(location.search).get('plan');
  var S = {
    plan: PLANS[urlPlan] ? urlPlan : 'classic',
    counts: {},
    sugar: 'regular',
    note: '',
    undo: null,
    modal: null,
    nutri: false /* full nutrition table expanded in the modal */,
  };
  var sheetOpen = false,
    autoSheetOpened = false,
    busy = false;

  function tot(c) {
    var s = 0,
      k;
    for (k in c) s += c[k];
    return s;
  }
  function trimCounts(c, n) {
    var out = {},
      s = 0;
    F.forEach(function (f) {
      var q = c[f.id] || 0;
      if (!q) return;
      var take = Math.min(q, n - s);
      if (take > 0) {
        out[f.id] = take;
        s += take;
      }
    });
    return out;
  }

  var ctlCache = {};

  /* ---- render ---- */
  function render() {
    var p = PLANS[S.plan],
      n = tot(S.counts),
      full = n >= p.n;

    /* Title & subtitle */
    var titleEl = document.getElementById('p-title');
    titleEl.textContent = t().title;
    titleEl.setAttribute('data-en', UI.en.title);
    var subEl = document.getElementById('p-sub');
    subEl.textContent = t().sub(p);
    subEl.setAttribute('data-en', UI.en.sub(p));

    /* Step indicator */
    var stepsEn = UI.en.steps;
    var stepsOut =
      '<div class="cstep done"><span class="cnum">✓</span><span data-en="' +
      stepsEn[0] +
      '">' +
      t().steps[0] +
      '</span></div><div class="csep"></div>';
    stepsOut +=
      '<div class="cstep act"><span class="cnum">2</span><span data-en="' +
      stepsEn[1] +
      '">' +
      t().steps[1] +
      '</span></div><div class="csep"></div>';
    stepsOut +=
      '<div class="cstep"><span class="cnum">3</span><span data-en="' +
      stepsEn[2] +
      '">' +
      t().steps[2] +
      '</span></div>';
    document.getElementById('p-steps').innerHTML = stepsOut;

    /* Plan pills */
    document.getElementById('p-pills').innerHTML = ORDER.map(function (k) {
      var pl = PLANS[k];
      return (
        '<button class="pill2' +
        (S.plan === k ? ' on' : '') +
        '" data-act="plan" data-plan="' +
        k +
        '">' +
        '<div><b data-en="' +
        UI.en.pn(pl) +
        '">' +
        t().pn(pl) +
        '</b><span data-en="' +
        dots(UI.en.meta(pl)) +
        '">' +
        dots(t().meta(pl)) +
        '</span></div><em>RM' +
        pl.price +
        '</em></button>'
      );
    }).join('');

    ctlCache = {};
    document.getElementById('p-grid').innerHTML = F.map(function (f) {
      return (
        '<div class="row2" data-fid="' +
        f.id +
        '"><button class="rimg" data-act="info" data-id="' +
        f.id +
        '" title="' +
        t().nm(f) +
        '"><img src="' +
        f.img +
        '" alt="' +
        f.en +
        '" loading="lazy" decoding="async" width="72" height="72">' +
        '<span class="rmore" aria-hidden="true">+</span></button>' +
        '<div class="rtx"><b><span data-en="' +
        f.en +
        '">' +
        t().nm(f) +
        '</span>' +
        (f.best
          ? '<span class="cbest" data-en="' +
            UI.en.rec +
            '">' +
            t().rec +
            '</span>'
          : '') +
        '</b>' +
        '<em data-en="' +
        dots(f.te) +
        '">' +
        dots(t().tg(f)) +
        '</em></div>' +
        '<div class="rctl"></div></div>'
      );
    }).join('');

    /* Sidebar — plan summary */
    document.getElementById('p-plan').innerHTML =
      '<div><b data-en="' +
      UI.en.pn(p) +
      '">' +
      t().pn(p) +
      '</b><span data-en="' +
      dots(UI.en.meta(p)) +
      '">' +
      dots(t().meta(p)) +
      '</span></div><em>RM' +
      p.price +
      '</em>';

    /* Sugar selector */
    document.getElementById('p-sugar').innerHTML =
      '<div class="csugar-head"><span class="olbl2" data-en="' +
      UI.en.sugarLbl +
      '">' +
      t().sugarLbl +
      '</span><small data-en="' +
      UI.en.sugarNote +
      '">' +
      t().sugarNote +
      '</small></div>' +
      '<div class="cseg">' +
      SUGAR.map(function (s) {
        return (
          '<button class="' +
          (S.sugar === s.k ? 'on' : '') +
          '" data-act="sugar" data-sugar="' +
          s.k +
          '" data-en="' +
          s.en +
          '">' +
          t().sugarName(s) +
          '</button>'
        );
      }).join('') +
      '</div>';

    /* Nudge */
    var target =
      S.plan === 'trial' ? 'classic' : S.plan === 'classic' ? 'monthly' : null;
    var nper = target ? PLANS[target].per : '';
    document.getElementById('p-nudge').innerHTML =
      '<p data-en="' +
      tpl(UI.en.nudge[S.plan], { per: nper }) +
      '">' +
      tpl(t().nudge[S.plan], { per: nper }) +
      '</p>' +
      (target
        ? '<button data-act="plan" data-plan="' +
          target +
          '" data-en="' +
          UI.en.switchTo[target] +
          ' →">' +
          t().switchTo[target] +
          ' →</button>'
        : '');

    /* Sidebar header label & footer text — language only */
    var lblEl = document.getElementById('p-lbl');
    lblEl.textContent = t().yourSet;
    lblEl.setAttribute('data-en', UI.en.yourSet);
    var footEl = document.getElementById('p-foot');
    footEl.textContent = t().foot;
    footEl.setAttribute('data-en', UI.en.foot);

    syncCounts();
  }

  function syncCounts() {
    var p = PLANS[S.plan],
      n = tot(S.counts),
      full = n >= p.n;
    var grid = document.getElementById('p-grid');
    if (grid) {
      for (var i = 0; i < grid.children.length; i++) {
        var row = grid.children[i];
        var fid = row.getAttribute('data-fid');
        if (!fid) continue;
        var html = ctlHtml(fid, full);
        if (ctlCache[fid] === html) continue;
        ctlCache[fid] = html;
        var slot = row.querySelector('.rctl');

        if (slot) slot.innerHTML = html;
      }
    }

    /* Progress bar */
    var bar = document.getElementById('p-bar');
    bar.className = 'cbar' + (full ? ' full' : '');
    bar.firstElementChild.style.width = Math.min(100, (n / p.n) * 100) + '%';
    var progtxEl = document.getElementById('p-progtx');
    progtxEl.textContent = full ? t().progDone : t().prog(n, p.n);
    progtxEl.setAttribute(
      'data-en',
      full ? UI.en.progDone : UI.en.prog(n, p.n),
    );

    var wk = p.weekly
      ? '<div class="cwk-line">' +
        '<span class="wtag" data-en="' +
        UI.en.weekTag +
        '">' +
        t().weekTag +
        '</span><span data-en="' +
        UI.en.weekNote +
        '">' +
        t().weekNote +
        '</span></div>'
      : '';
    var noteHtml = '';
    if (S.note === 'trimmed') {
      noteHtml =
        '<div class="cwk-note" data-en="' +
        UI.en.trimmed(p.n) +
        '">' +
        t().trimmed(p.n) +
        '</div>';
    } else if (S.note === 'cleared') {
      noteHtml =
        '<div class="cwk-note" data-en="' +
        UI.en.cleared +
        " <button data-act='undo'>" +
        UI.en.undo +
        '</button>">' +
        t().cleared +
        ' <button data-act="undo">' +
        t().undo +
        '</button></div>';
    }
    document.getElementById('p-week').innerHTML = wk + noteHtml;

    /* Flavor list in sidebar */
    var picked = F.filter(function (f) {
      return S.counts[f.id];
    });
    document.getElementById('p-list').innerHTML = picked.length
      ? picked
          .map(function (f) {
            return (
              '<div class="cli"><i style="background-image:url(' +
              f.img +
              ')"></i><span data-en="' +
              f.en +
              '">' +
              t().nm(f) +
              '</span><em>×' +
              S.counts[f.id] +
              '</em></div>'
            );
          })
          .join('')
      : '<div class="cempty" data-en="' +
        UI.en.empty +
        '">' +
        t().empty +
        '</div>';

    /* Clear button */
    var cl = document.getElementById('p-clear');
    cl.textContent = t().clear;
    cl.setAttribute('data-en', UI.en.clear);
    cl.disabled = picked.length === 0;

    /* Auto-fill button */
    var auto = document.getElementById('p-auto');
    auto.style.display = full ? 'none' : 'block';
    auto.textContent = t().auto;
    auto.setAttribute('data-en', UI.en.auto);

    /* Checkout button */
    var b = document.getElementById('p-btn');
    b.className = full ? 'obtn cgo' : 'obtn cdis';
    b.disabled = !full || busy;
    var btnText = busy
      ? t().adding
      : full
        ? t().go(p.price)
        : t().need(p.n - n);
    var btnEn = busy
      ? UI.en.adding
      : full
        ? UI.en.go(p.price)
        : UI.en.need(p.n - n);
    b.textContent = btnText;
    b.setAttribute('data-en', btnEn);

    /* Mobile bottom bar */
    document.getElementById('m-count').textContent = n + ' / ' + p.n;
    document.getElementById('m-price').textContent = 'RM ' + p.price;
    var mb = document.getElementById('m-btn');
    mb.className = full ? 'obtn cgo' : 'obtn cdis';
    mb.disabled = !full || busy;
    mb.textContent = btnText;
    mb.setAttribute('data-en', btnEn);

    /* Auto-open mobile aside when all bottles are picked */
    if (
      full &&
      window.matchMedia('(max-width: 767px)').matches &&
      !sheetOpen &&
      !autoSheetOpened
    ) {
      autoSheetOpened = true;
      setSheet(true);
    }
    if (!full) {
      autoSheetOpened = false;
    }

    renderModal();
  }

  /* ---- flavor detail popover ---- */
  function ctlHtml(id, full) {
    var q = S.counts[id] || 0;
    return q === 0
      ? '<button class="addb2"' +
          (full ? ' disabled' : '') +
          ' data-act="inc" data-id="' +
          id +
          '" data-en="' +
          UI.en.add +
          ' +">' +
          t().add +
          ' +</button>'
      : '<div class="stp2"><button data-act="dec" data-id="' +
          id +
          '">−</button><b>' +
          q +
          '</b><button data-act="inc" data-id="' +
          id +
          '"' +
          (full ? ' disabled' : '') +
          '>+</button></div>';
  }
  var modalCloseTimer = null;
  function renderModal() {
    var m = document.getElementById('p-modal');
    if (S.modal == null) {
      /* Fade out, then hide once the transition has finished. */
      if (m.classList.contains('open') && !modalCloseTimer) {
        m.classList.remove('show');
        var reduce = window.matchMedia(
          '(prefers-reduced-motion: reduce)',
        ).matches;
        modalCloseTimer = setTimeout(
          function () {
            modalCloseTimer = null;
            m.classList.remove('open');
          },
          reduce ? 0 : 240,
        );
      }
      return;
    }
    var f = BY[S.modal],
      node = srcNode(S.modal),
      p = PLANS[S.plan],
      full = tot(S.counts) >= p.n;
    if (modalCloseTimer) {
      clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }
    if (!m.classList.contains('open')) {
      m.classList.add('open');
      void m.offsetWidth; /* flush so the fade-in transition runs */
    }
    m.classList.add('show');

    var card = m.querySelector('.pcardm');
    card.innerHTML = '<button class="pmx" data-act="minfo-close">×</button>';
    if (!node) return;

    var photo = node.querySelector('.flavor-photo');
    if (photo) {
      var pic = photo.cloneNode(false);
      pic.className = 'pmimg';
      pic.removeAttribute('loading');
      card.appendChild(pic);
    }

    var detail = node.querySelector('.flavor-detail').cloneNode(true);
    detail.removeAttribute('hidden');
    detail.className = 'pmc';

    /* CTA and nutrition toggle share a row so the card stays short */
    var act = document.createElement('div');
    act.className = 'pmact';
    act.innerHTML = '<div class="rctl">' + ctlHtml(f.id, full) + '</div>';
    var toggle = detail.querySelector('.fmn-toggle');
    if (toggle) {
      toggle.setAttribute('data-act', 'nutri');
      toggle.setAttribute('aria-expanded', S.nutri ? 'true' : 'false');
      toggle.dataset.zh =
        (S.nutri
          ? toggle.getAttribute('data-less-zh')
          : toggle.getAttribute('data-more-zh')) + (S.nutri ? ' −' : ' ＋');
      toggle.dataset.en =
        (S.nutri
          ? toggle.getAttribute('data-less-en')
          : toggle.getAttribute('data-more-en')) + (S.nutri ? ' −' : ' ＋');
      act.appendChild(toggle);
    }
    detail.appendChild(act);
    card.appendChild(detail);

    var panel = detail.querySelector('.fmn');
    if (panel) {
      panel.hidden = !S.nutri;
      card.appendChild(panel);
    }

    applyLangIn(card);

    if (f.best) {
      var h3 = card.querySelector('.pmc h3');
      if (h3) {
        h3.insertAdjacentHTML(
          'beforeend',
          '<span class="cbest">' + t().rec + '</span>',
        );
      }
    }
  }

  /* ---- sugar data (labels from CFG or defaults) ---- */
  var SUGAR = [
    { k: 'regular', cn: '正常甜', en: 'Regular' },
    { k: 'less', cn: '少甜', en: 'Less Sweet' },
    { k: 'zero', cn: '不甜', en: 'Unsweetened' },
  ];
  if (CFG.ui && CFG.ui.sugar) {
    SUGAR.forEach(function (s) {
      if (CFG.ui.sugar[s.k]) {
        if (CFG.ui.sugar[s.k].zh) s.cn = CFG.ui.sugar[s.k].zh;
        if (CFG.ui.sugar[s.k].en) s.en = CFG.ui.sugar[s.k].en;
      }
    });
  }

  /* ---- fly-to-summary animation ---- */
  function fly(srcImg) {
    if (!srcImg) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var mbar = document.getElementById('m-bar');
    var tgt =
      getComputedStyle(mbar).display !== 'none'
        ? mbar
        : document.getElementById('p-bar');
    if (!tgt || !srcImg.getBoundingClientRect) return;
    var a = srcImg.getBoundingClientRect(),
      b = tgt.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var ghost = srcImg.cloneNode();
    ghost.style.cssText =
      'position:fixed;z-index:100;pointer-events:none;border-radius:14px;object-fit:cover;' +
      'left:' +
      a.left +
      'px;top:' +
      a.top +
      'px;width:' +
      a.width +
      'px;height:' +
      a.height +
      'px;';
    document.body.appendChild(ghost);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2),
      dy = b.top + b.height / 2 - (a.top + a.height / 2);
    ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        {
          transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)',
          opacity: 0.25,
        },
      ],
      { duration: 550, easing: 'cubic-bezier(.5,-0.1,.3,1)' },
    ).onfinish = function () {
      ghost.remove();
      tgt.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.03)' },
          { transform: 'scale(1)' },
        ],
        { duration: 220 },
      );
    };
  }

  /* ---- mobile summary sheet ---- */

  var bodyLockY = 0;
  var bodyLocked = false;
  var overscrollShieldTimer = null;
  var overscrollShieldActive = false;

  function onOverscrollShieldMove(e) {
    if (e.cancelable) e.preventDefault();
  }

  function armOverscrollShield(ms) {
    if (overscrollShieldTimer) {
      clearTimeout(overscrollShieldTimer);
      overscrollShieldTimer = null;
    }
    document.documentElement.classList.add('fp-sheet-lock');
    if (!overscrollShieldActive) {
      overscrollShieldActive = true;
      document.addEventListener('touchmove', onOverscrollShieldMove, {
        passive: false,
        capture: true,
      });
      document.addEventListener('wheel', onOverscrollShieldMove, {
        passive: false,
        capture: true,
      });
    }
    overscrollShieldTimer = setTimeout(function () {
      overscrollShieldTimer = null;
      if (!bodyLocked) {
        document.removeEventListener('touchmove', onOverscrollShieldMove, true);
        document.removeEventListener('wheel', onOverscrollShieldMove, true);
        overscrollShieldActive = false;
        document.documentElement.classList.remove('fp-sheet-lock');
      }
    }, ms || 450);
  }

  function lockBody() {
    if (bodyLocked) return;
    bodyLocked = true;
    bodyLockY = window.scrollY || window.pageYOffset || 0;
    var html = document.documentElement;
    html.classList.add('fp-sheet-lock');
    html.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + bodyLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    syncFpHeader(bodyLockY);
  }

  function unlockBody(opts) {
    if (!bodyLocked) return;
    bodyLocked = false;
    var y = bodyLockY;
    var html = document.documentElement;
    var fromDrag = opts && opts.fromDrag;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    html.style.overflow = '';

    /* Instant restore — avoid smooth scroll which looks like a bounce. */
    if (typeof window.scrollTo === 'function') {
      try {
        window.scrollTo({ top: y, left: 0, behavior: 'instant' });
      } catch (err) {
        window.scrollTo(0, y);
      }
    } else {
      window.scrollTo(0, y);
    }
    syncFpHeader(y);

    if (fromDrag) {
      /* Keep overscroll killed until the OS finishes the gesture. */
      armOverscrollShield(480);
    } else if (!overscrollShieldActive) {
      html.classList.remove('fp-sheet-lock');
    }
  }

  var DISMISS_PX = 96;
  var DISMISS_V = 0.55; /* px/ms */

  function clearSheetDrag(aside) {
    aside.classList.remove('dragging');
    aside.style.transform = '';
    aside.style.transition = '';
  }

  function unbindSheetDismiss(aside) {
    var h = aside._dismissHandlers;
    if (!h) return;
    aside.removeEventListener('touchstart', h.onStart);
    aside.removeEventListener('touchmove', h.onMove);
    aside.removeEventListener('touchend', h.onEnd);
    aside.removeEventListener('touchcancel', h.onEnd);
    delete aside._dismissHandlers;
  }

  function finishSheetClose(aside, opts) {
    if (!aside) aside = document.querySelector('.cside');
    unbindSheetDismiss(aside);
    sheetOpen = false;
    if (aside) aside.classList.remove('open');
    var tg = document.getElementById('m-toggle');
    if (tg) tg.classList.remove('open');

    requestAnimationFrame(function () {
      if (aside) clearSheetDrag(aside);
    });

    if (opts && opts.fromDrag) {
      armOverscrollShield(700);
      setTimeout(function () {
        unlockBody({ fromDrag: true });
      }, 120);
    } else {
      unlockBody(opts);
    }
  }

  function bindSheetDismiss(aside) {
    if (aside._dismissHandlers) return;

    var startY = 0;
    var startT = 0;
    var dragY = 0;
    var dragging = false;
    var maybe = false; /* touch began at scroll top */
    var closing = false;

    var onStart = function (e) {
      if (closing || !e.touches || !e.touches.length) return;
      startY = e.touches[0].clientY;
      startT = Date.now();
      dragY = 0;
      dragging = false;
      maybe = aside.scrollTop <= 0;
      if (!aside.classList.contains('dragging')) {
        aside.style.transform = '';
        aside.style.transition = '';
      }
    };

    var onMove = function (e) {
      if (closing || !e.touches || !e.touches.length) return;
      var y = e.touches[0].clientY;
      var dy = y - startY;

      /* User scrolled content up first — never steal the gesture. */
      if (!dragging && aside.scrollTop > 0) {
        maybe = false;
        return;
      }

      /* Only start a dismiss drag when pulling down from the top. */
      if (!dragging) {
        if (!maybe || dy <= 0) return;
        dragging = true;
        aside.classList.add('dragging');
      }

      if (dragging) {
        /* Slight resistance so it feels weighted; never above rest. */
        dragY = Math.max(0, dy * 0.92);
        aside.style.transform = 'translateY(' + dragY + 'px)';
        /* Non-passive: block scroll chaining to the page behind. */
        if (e.cancelable) e.preventDefault();
      }
    };

    var onEnd = function () {
      if (closing || !dragging) {
        maybe = false;
        dragging = false;
        return;
      }
      var endV = dragY / Math.max(1, Date.now() - startT);
      var shouldClose = dragY >= DISMISS_PX || endV >= DISMISS_V;

      aside.classList.remove('dragging');

      if (shouldClose) {
        closing = true;

        armOverscrollShield(700);

        var h = aside.offsetHeight || 400;
        aside.style.transition = 'transform 0.28s ease';
        aside.style.transform = 'translateY(' + Math.max(dragY, h + 24) + 'px)';
        var finished = false;
        var done = function () {
          if (finished) return;
          finished = true;
          aside.removeEventListener('transitionend', done);
          finishSheetClose(aside, { fromDrag: true });
        };
        aside.addEventListener('transitionend', done);
        setTimeout(done, 360);
      } else {
        /* Spring back to rest. */
        aside.style.transition = 'transform 0.28s ease';
        aside.style.transform = 'translateY(0)';
        var backDone = false;
        var back = function () {
          if (backDone) return;
          backDone = true;
          aside.removeEventListener('transitionend', back);
          clearSheetDrag(aside);
        };
        aside.addEventListener('transitionend', back);
        setTimeout(back, 360);
      }

      dragging = false;
      maybe = false;
      dragY = 0;
    };

    aside.addEventListener('touchstart', onStart, { passive: true });
    aside.addEventListener('touchmove', onMove, { passive: false });
    aside.addEventListener('touchend', onEnd, { passive: true });
    aside.addEventListener('touchcancel', onEnd, { passive: true });

    aside._dismissHandlers = {
      onStart: onStart,
      onMove: onMove,
      onEnd: onEnd,
    };
  }

  function setSheet(open) {
    var aside = document.querySelector('.cside');
    if (!aside) return;

    if (!open) {
      unbindSheetDismiss(aside);
      clearSheetDrag(aside);
      sheetOpen = false;
      aside.classList.remove('open');
      var tg = document.getElementById('m-toggle');
      if (tg) tg.classList.remove('open');
      unlockBody();
      return;
    }

    sheetOpen = true;
    aside.classList.add('open');
    var tgOpen = document.getElementById('m-toggle');
    if (tgOpen) tgOpen.classList.add('open');
    lockBody();
    bindSheetDismiss(aside);
  }

  /* ---- checkout: real cart when a variant ID is set ---- */
  function mixSummary(lang) {
    var nameKey = lang === 'en' ? 'en' : 'cn';
    return F.filter(function (f) {
      return S.counts[f.id];
    })
      .map(function (f) {
        return '• ' + f[nameKey] + ' ×' + S.counts[f.id];
      })
      .join('\n');
  }
  function mixCode() {
    return F.filter(function (f) {
      return S.counts[f.id];
    })
      .sort(function (a, b) {
        return a.id - b.id;
      })
      .map(function (f) {
        return f.code + ':' + S.counts[f.id];
      })
      .join(',');
  }
  function sugarSummary(lang) {
    var s = SUGAR.filter(function (x) {
      return x.k === S.sugar;
    })[0];
    return s ? s[lang === 'en' ? 'en' : 'cn'] : '';
  }
  var pickerFired = { start: false, autofill: false, confirmed: {} };

  function trackPickerAction(act, planBefore, totBefore) {
    var T = window.sbTrack;
    if (!T) return;

    var total = tot(S.counts);
    var n = PLANS[S.plan].n;
    if (act === 'auto') pickerFired.autofill = true;

    if (act === 'plan' && S.plan !== planBefore) {
      T.push('plan_change', {
        plan_from: planBefore,
        plan_to: S.plan,
        bottles_kept: total,
        bottles_trimmed: Math.max(totBefore - total, 0),
      });
    }

    if (act === 'sugar') {
      T.push('sugar_select', { sugar: S.sugar, plan: S.plan });
    }

    if (act === 'info' && S.modal != null) {
      T.push('view_flavor_detail', {
        flavor_code: (BY[S.modal] && BY[S.modal].code) || '',
        detail_source: 'picker',
        plan: S.plan,
      });
    }

    if (act === 'auto') {
      T.push('use_autofill', {
        filled_count: Math.max(total - totBefore, 0),
        plan: S.plan,
      });
    }

    if (!pickerFired.start && totBefore === 0 && total > 0) {
      pickerFired.start = true;
      T.push('flavor_start', {
        plan: S.plan,
        used_autofill: pickerFired.autofill,
      });
    }

    if (total === n && !pickerFired.confirmed[S.plan]) {
      pickerFired.confirmed[S.plan] = true;
      T.push('flavor_mix_confirmed', {
        ecommerce: trackEcommerce(S.plan),
        flavor_mix: mixCode(),
        sugar: S.sugar,
        used_autofill: pickerFired.autofill,
      });
    }
  }

  function trackContext(checkoutLang) {
    var T = window.sbTrack;
    var attribution =
      T && typeof T.metaAttribution === 'function' ? T.metaAttribution() : {};
    return {
      eid: T ? T.eventId() : '',
      cid: T ? T.clientId() : '',
      sid: T ? T.sessionId() : '',
      fbp: T ? T.fbp() : '',
      fbc: T ? T.fbc() : '',
      ttclid: T ? T.ttclid() : '',
      ttp: T ? T.ttp() : '',
      mix: mixCode(),
      sugar: S.sugar,
      lang: checkoutLang || (T ? T.lang() : 'zh'),
      source: attribution.source || '',
      campaignName: attribution.campaignName || '',
      adsetName: attribution.adsetName || '',
      adName: attribution.adName || '',
      placement: attribution.placement || '',
    };
  }

  function trackingPayload(ctx) {
    var payload = {
      eid: ctx.eid,
      cid: ctx.cid,
      sid: ctx.sid,
      fbp: ctx.fbp,
      fbc: ctx.fbc,
      ttclid: ctx.ttclid,
      ttp: ctx.ttp,
      mix: ctx.mix,
      sugar: ctx.sugar,
      lang: ctx.lang,
    };
    ['source', 'campaignName', 'adsetName', 'adName', 'placement'].forEach(
      function (key) {
        if (ctx[key]) payload[key] = ctx[key];
      },
    );
    return payload;
  }

  function writeTrackAttribute(value) {
    return fetch(cartUrl('update'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _sb_track: value,
        },
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('tracking attribute update failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.attributes || cart.attributes._sb_track !== value) {
          throw new Error('tracking attribute verification failed');
        }
        return cart;
      });
  }

  function trackAttributes(ctx) {
    var value = JSON.stringify(trackingPayload(ctx));
    return writeTrackAttribute(value).catch(function () {
      return writeTrackAttribute(value);
    });
  }

  function trackCheckout(ctx, done) {
    var T = window.sbTrack;
    if (!T) return done();

    T.setCookie('sb_eid', ctx.eid);
    T.setCookie('sb_mix', ctx.mix);
    T.setCookie('sb_cid', ctx.cid);
    T.setCookie('sb_sid', ctx.sid);
    T.setCookie('sb_sugar', ctx.sugar);

    var fired = false;
    function once() {
      if (fired) return;
      fired = true;
      done();
    }

    T.push('add_to_cart', {
      ecommerce: trackEcommerce(S.plan),
      flavor_mix: ctx.mix,
      sugar: ctx.sugar,
      event_id: ctx.eid,
      eventCallback: once,
      eventTimeout: 900,
    });
    setTimeout(once, 1000);
  }

  function finishCheckout(go, checkoutLang) {
    var ctx;
    try {
      ctx = trackContext(checkoutLang);
    } catch (e) {
      return go();
    }
    var proceed = function () {
      try {
        trackCheckout(ctx, go);
      } catch (e) {
        go();
      }
    };
    try {
      trackAttributes(ctx).then(proceed, proceed);
    } catch (e) {
      proceed();
    }
  }

  function cartUrl(action) {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return action === 'get'
      ? root + 'cart.js'
      : root + 'cart/' + action + '.js';
  }

  function cartError(stage, reason, detail) {
    var code =
      'SB-' + String(stage || 'CART') + '-' + String(reason || 'UNKNOWN');
    var error = new Error(code + (detail ? ': ' + detail : ''));
    error.name = 'SweetBitesCartError';
    error.code = code;
    error.stage = stage;
    error.reason = reason;
    error.status = typeof reason === 'number' ? reason : 0;
    error.detail = detail || '';
    return error;
  }

  function cartErrorDetail(data, fallback) {
    if (data && typeof data === 'object') {
      return String(data.description || data.message || fallback || '');
    }
    return String(fallback || '');
  }

  function cartRequest(stage, action, options) {
    return fetch(cartUrl(action), options)
      .then(function (response) {
        return response.text().then(function (text) {
          var data = null;
          if (text) {
            try {
              data = JSON.parse(text);
            } catch (e) {
              if (response.ok) {
                throw cartError(stage, 'DATA', 'Invalid JSON response');
              }
            }
          }
          if (!response.ok) {
            throw cartError(
              stage,
              response.status || 'HTTP',
              cartErrorDetail(data, response.statusText),
            );
          }
          if (!data || typeof data !== 'object') {
            throw cartError(stage, 'DATA', 'Missing cart response');
          }
          return data;
        });
      })
      .catch(function (error) {
        if (error && error.code) throw error;
        throw cartError(
          stage,
          'NET',
          error && error.message ? error.message : 'Network request failed',
        );
      });
  }

  function clearCart() {
    return cartRequest('CLEAR', 'clear', {
      method: 'POST',
      credentials: 'same-origin',
    }).then(function (cart) {
      if (Number(cart.item_count) !== 0) {
        throw cartError('CLEAR', 'VERIFY', 'Cart is not empty');
      }
      return cart;
    });
  }

  function cartItemMatches(item, vid, props) {
    if (!item || Number(item.variant_id || item.id) !== Number(vid)) {
      return false;
    }
    if (Number(item.quantity) !== 1) return false;
    var itemProps = item.properties || {};
    for (var key in props) {
      if (
        Object.prototype.hasOwnProperty.call(props, key) &&
        String(itemProps[key] == null ? '' : itemProps[key]) !==
          String(props[key] == null ? '' : props[key])
      ) {
        return false;
      }
    }
    return true;
  }

  function cartContainsOnlyExpectedItem(cart, vid, props) {
    if (!cart || Number(cart.item_count) !== 1 || !Array.isArray(cart.items)) {
      return false;
    }
    return cart.items.some(function (item) {
      return cartItemMatches(item, vid, props);
    });
  }

  function addCartItem(vid, props) {
    return cartRequest('ADD', 'add', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(vid), quantity: 1, properties: props }],
      }),
    }).then(function (data) {
      if (
        !Array.isArray(data.items) ||
        !data.items.some(function (item) {
          return cartItemMatches(item, vid, props);
        })
      ) {
        throw cartError('ADD', 'VERIFY', 'Added item was not returned');
      }
      return data;
    });
  }

  function readCart() {
    return cartRequest('READ', 'get', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
  }

  function retryableCartError(error) {
    if (!error) return false;
    if (
      error.reason === 'NET' ||
      error.reason === 'DATA' ||
      error.reason === 'VERIFY'
    ) {
      return true;
    }
    return error.status === 429 || error.status >= 500;
  }

  function staleCart422(error) {
    if (!error || error.stage !== 'ADD' || error.status !== 422) return false;
    var detail = String(error.detail || '').toLowerCase();
    return (
      /can(?:not|['’]t) add more.*cart/.test(detail) ||
      /can only add .*cart/.test(detail) ||
      /all available.*cart/.test(detail) ||
      /already (?:in|present|added).*cart/.test(detail) ||
      /already have.*cart/.test(detail) ||
      /(?:maximum|max).*quantity.*cart/.test(detail) ||
      /cart.*(?:maximum|max).*quantity/.test(detail) ||
      /quantity.*already.*cart/.test(detail)
    );
  }

  function inspectAddFailure(error) {
    return (
      error &&
      error.stage === 'ADD' &&
      (retryableCartError(error) || staleCart422(error))
    );
  }

  function addWithRecovery(vid, props, canRetry) {
    return addCartItem(vid, props).catch(function (error) {
      if (!inspectAddFailure(error)) throw error;

      return readCart().then(
        function (cart) {
          if (cartContainsOnlyExpectedItem(cart, vid, props)) return cart;
          if (!canRetry) throw error;
          return cartAttempt(vid, props, false);
        },
        function () {
          if (!canRetry) throw error;
          return cartAttempt(vid, props, false);
        },
      );
    });
  }

  function cartAttempt(vid, props, canRetry) {
    return clearCart().then(
      function () {
        return addWithRecovery(vid, props, canRetry);
      },
      function (error) {
        if (canRetry && retryableCartError(error)) {
          return cartAttempt(vid, props, false);
        }
        throw error;
      },
    );
  }

  function prepareCart(vid, props) {
    return cartAttempt(vid, props, true);
  }

  function showCartError(error) {
    var code = error && error.code ? error.code : 'SB-CART-UNKNOWN';
    if (window.console && typeof window.console.error === 'function') {
      window.console.error('[SweetBites cart]', code, error);
    }
    alert(t().cartErr + '\n\n[' + code + ']');
  }

  function checkoutProperties(lang, freeBottles) {
    var bottleWord = freeBottles === 1 ? 'bottle' : 'bottles';
    var flavorWord = freeBottles === 1 ? 'flavor' : 'flavors';
    var props = {};

    if (lang === 'en') {
      props['😋 Flavors'] = mixSummary(lang);
      props['🍬 Sweetness'] = sugarSummary(lang);
      props['🎁 First Order Perk'] =
        'Use code FIRSTORDER below to get ' +
        freeBottles +
        ' free ' +
        bottleWord +
        '. After ordering, we’ll contact you to confirm the ' +
        flavorWord +
        '.';
      return props;
    }

    props['😋 口味'] = mixSummary(lang);
    props['🍬 甜度'] = sugarSummary(lang);
    props['🎁 首单专享'] =
      '在下方输入优惠码 FIRSTORDER，免费加送 ' +
      freeBottles +
      ' 瓶。下单后，我们会联系您确认口味。';
    return props;
  }

  function checkout() {
    var vid = CFG.variants && CFG.variants[S.plan];
    var freeBottles = { trial: 1, classic: 2, monthly: 3 }[S.plan] || 1;
    var T = window.sbTrack;
    var lang = T && T.lang() === 'en' ? 'en' : 'zh';
    var props = checkoutProperties(lang, freeBottles);
    if (vid) {
      busy = true;
      syncCounts();
      prepareCart(vid, props)
        .then(function () {
          finishCheckout(
            function () {
              location.href = '/checkout';
            },
            lang,
          );
        })
        .catch(function (error) {
          busy = false;
          syncCounts();
          showCartError(error);
        });
    } else {
      alert(
        '[' +
          PLANS[S.plan].en +
          '] ' +
          props[lang === 'en' ? '😋 Flavors' : '😋 口味'] +
          ' — ' +
          props[lang === 'en' ? '🍬 Sweetness' : '🍬 甜度'] +
          '\n\n(Set the plan variant IDs in the section settings to enable real add-to-cart.)',
      );
    }
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-act]');
    if (!el || el.disabled) return;
    var act = el.dataset.act,
      id = el.dataset.id,
      p = PLANS[S.plan];
    var planBefore = S.plan,
      totBefore = tot(S.counts);
    var full_rebuild = act === 'plan' || act === 'sugar';
    var modal_only = act === 'info' || act === 'nutri' || act === 'minfo-close';
    if (act === 'plan') {
      if (S.plan !== el.dataset.plan) {
        S.plan = el.dataset.plan;
        p = PLANS[S.plan];
        var before = tot(S.counts);
        S.counts = trimCounts(S.counts, p.n);
        S.note = tot(S.counts) < before ? 'trimmed' : '';
      }
    } else if (act === 'inc') {
      if (tot(S.counts) < p.n) {
        S.counts[id] = (S.counts[id] || 0) + 1;
        S.note = '';
        var host = el.closest('.row2, .pcardm');
        if (host) fly(host.querySelector('img'));
      }
    } else if (act === 'dec') {
      S.counts[id]--;
      if (S.counts[id] <= 0) delete S.counts[id];
      S.note = '';
    } else if (act === 'clear') {
      S.undo = JSON.parse(JSON.stringify(S.counts));
      S.counts = {};
      S.note = 'cleared';
    } else if (act === 'undo') {
      if (S.undo) {
        S.counts = trimCounts(S.undo, p.n);
        S.undo = null;
      }
      S.note = '';
    } else if (act === 'auto') {
      var i = 0;
      while (tot(S.counts) < p.n) {
        var bid = BEST[i % BEST.length];
        S.counts[bid] = (S.counts[bid] || 0) + 1;
        i++;
      }
      S.note = '';
    } else if (act === 'sugar') {
      S.sugar = el.dataset.sugar;
    } else if (act === 'info') {
      S.modal = +id;
      S.nutri = false;
    } else if (act === 'nutri') {
      S.nutri = !S.nutri;
    } else if (act === 'minfo-close') {
      S.modal = null;
    } else if (act === 'sheet') {
      setSheet(!sheetOpen);
      return;
    } else if (act === 'checkout') {
      checkout();
      return;
    } else return;
    trackPickerAction(act, planBefore, totBefore);
    if (full_rebuild) render();
    else if (modal_only) renderModal();
    else syncCounts();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (S.modal != null) {
        S.modal = null;
        renderModal();
      }
      if (sheetOpen) setSheet(false);
    }
  });

  /* ---- language: follow the theme header's 中/EN toggle ---- */
  function applyLangIn(root) {
    root.querySelectorAll('[data-en]').forEach(function (el) {
      if (SRC && SRC.contains(el)) return;
      if (el.dataset.zh == null) el.dataset.zh = el.innerHTML;
      el.innerHTML = dots(LANG === 'en' ? el.dataset.en : el.dataset.zh);
    });
  }
  function applyStatic() {
    applyLangIn(document);
  }

  /* Listen for language changes dispatched by custom.js (same-tab) */
  document.addEventListener('sb:lang-changed', function (e) {
    LANG =
      (e.detail && e.detail.lang) || localStorage.getItem('sb_lang') || 'zh';
    render();
    applyStatic();
  });
  /* Fallback for cross-tab changes */
  window.addEventListener('storage', function (e) {
    if (e.key === 'sb_lang' && e.newValue) {
      LANG = e.newValue;
      render();
      applyStatic();
    }
  });

  /* ---- header scroll state ---- */
  var fpHeader = document.querySelector('.fp-header');
  var fpScrolled = false;
  var fpTicking = false;
  function syncFpHeader(y) {
    if (!fpHeader) return;
    if (typeof y !== 'number') {
      y = bodyLocked ? bodyLockY : window.scrollY || window.pageYOffset || 0;
    }
    if (!fpScrolled && y > 8) {
      fpScrolled = true;
      fpHeader.classList.add('scrolled');
    } else if (fpScrolled && y < 5) {
      fpScrolled = false;
      fpHeader.classList.remove('scrolled');
    }
  }

  /* ---- desktop sticky sidebar ---- */
  var fpAside = document.querySelector('.cside');
  var fpMain = document.querySelector('.p-main');
  var fpFooter = document.querySelector('.fp-footer');
  var fpDesktopMq =
    window.matchMedia && window.matchMedia('(min-width: 768px)');
  var CSIDE_GAP = 20; /* preferred top (and bottom when lifting) inset */
  var CSIDE_GAP_MIN = 12;

  function clearCsideClamp() {
    if (!fpAside) return;
    fpAside.style.removeProperty('--cside-top');
    fpAside.style.removeProperty('--cside-max-h');
    fpAside.style.removeProperty('--cside-overflow');
  }

  function syncCsideSticky() {
    if (!fpAside) return;
    if (!fpDesktopMq || !fpDesktopMq.matches) {
      clearCsideClamp();
      return;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var headerBottom = fpHeader ? fpHeader.getBoundingClientRect().bottom : 76;
    if (!(headerBottom > 0)) headerBottom = 76;

    var limitBottom = vh;
    if (fpFooter) {
      var ft = fpFooter.getBoundingClientRect().top;
      if (ft < limitBottom) limitBottom = ft;
    }
    /* Sticky is clipped by its containing block (.p-main). */
    if (fpMain) {
      var mb = fpMain.getBoundingClientRect().bottom;
      if (mb < limitBottom) limitBottom = mb;
    }

    var bandTop = headerBottom;
    var bandBottom = limitBottom;
    var band = bandBottom - bandTop;
    if (band <= 0) {
      fpAside.style.setProperty('--cside-top', bandTop + 'px');
      fpAside.style.setProperty('--cside-max-h', '0px');
      fpAside.style.setProperty('--cside-overflow', 'hidden');
      return;
    }

    /* Natural content height (scrollHeight ignores current max-height). */
    var naturalH = fpAside.scrollHeight;
    if (!(naturalH > 0)) naturalH = fpAside.getBoundingClientRect().height;

    var gap = CSIDE_GAP;
    var minGap = CSIDE_GAP_MIN;
    var preferredTop = bandTop + gap;

    /* Plenty of room: normal sticky under the header — do not center. */
    if (naturalH + gap * 2 <= band) {
      fpAside.style.setProperty('--cside-top', preferredTop + 'px');
      fpAside.style.setProperty('--cside-max-h', 'none');
      fpAside.style.setProperty('--cside-overflow', 'visible');
      return;
    }

    var liftedTop = bandBottom - gap - naturalH;
    if (liftedTop >= bandTop + minGap) {
      fpAside.style.setProperty('--cside-top', liftedTop + 'px');
      fpAside.style.setProperty('--cside-max-h', 'none');
      fpAside.style.setProperty('--cside-overflow', 'visible');
      return;
    }

    /* Top is also tight but full height still fits → equal gaps (center). */
    if (naturalH + minGap * 2 <= band) {
      var centeredTop = bandTop + (band - naturalH) / 2;
      fpAside.style.setProperty('--cside-top', centeredTop + 'px');
      fpAside.style.setProperty('--cside-max-h', 'none');
      fpAside.style.setProperty('--cside-overflow', 'visible');
      return;
    }

    /* Truly too tall: equal min padding + scrollable content. */
    var maxH = Math.max(0, band - minGap * 2);
    fpAside.style.setProperty('--cside-top', bandTop + minGap + 'px');
    fpAside.style.setProperty('--cside-max-h', maxH + 'px');
    fpAside.style.setProperty('--cside-overflow', 'auto');
  }

  function onFpScrollOrResize() {
    if (bodyLocked) return;
    if (!fpTicking) {
      requestAnimationFrame(function () {
        syncFpHeader();
        syncCsideSticky();
        fpTicking = false;
      });
      fpTicking = true;
    }
  }

  window.addEventListener('scroll', onFpScrollOrResize, { passive: true });
  window.addEventListener('resize', onFpScrollOrResize, { passive: true });
  if (fpDesktopMq) {
    if (fpDesktopMq.addEventListener) {
      fpDesktopMq.addEventListener('change', onFpScrollOrResize);
    } else if (fpDesktopMq.addListener) {
      fpDesktopMq.addListener(onFpScrollOrResize);
    }
  }
  /* Initial paint + after fonts/images may shift layout. */
  syncCsideSticky();
  if (typeof ResizeObserver === 'function' && fpAside) {
    var ro = new ResizeObserver(function () {
      if (bodyLocked) return;
      syncCsideSticky();
    });
    ro.observe(fpAside);
    if (fpMain) ro.observe(fpMain);
    if (fpFooter) ro.observe(fpFooter);
  }

  applyStatic();
  render();
  syncCsideSticky();

  if (window.sbTrack) {
    window.sbTrack.push('view_item', {
      ecommerce: trackEcommerce(S.plan),
      entry_plan: PLANS[urlPlan] ? urlPlan : 'none',
    });
  }
})();
